const DEFAULT_REQUIRED_MESSAGE = "This field is required";
const DEFAULT_INTEGER_PATTERN = { value: /^-?\d+$/, message: "Please enter a whole number" };

export const buildValidationRule = (validation, customValidators = {}) => {
  if (!validation) return undefined;

  if (validation.custom) {
    return customValidators[validation.custom];
  }

  const rule = {};

  if (validation.required !== undefined) {
    rule.required = validation.required === true ? DEFAULT_REQUIRED_MESSAGE : validation.required;
  }
  if (validation.min !== undefined) rule.min = validation.min;
  if (validation.max !== undefined) rule.max = validation.max;
  if (validation.maxLength !== undefined) rule.maxLength = validation.maxLength;
  if (validation.pattern) rule.pattern = validation.pattern;
  if (validation.integer) rule.pattern = rule.pattern || DEFAULT_INTEGER_PATTERN;

  return rule;
};
